import NAME from "./constants";

export const getIsLoading = store => store[NAME].isLoading;